import React, { Component } from 'react';
import Main from "../routes/Main";
import { I18n } from 'react-i18next';

class App extends Component {
    render() {
        return (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <Main/>
                    )
                }
            </I18n>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/index.jsx